// Set deliberately wrong fallback values for easier debugging if something goes wrong.
const config = {
  API_BASE_URL: process.env?.REACT_APP_API_BASE_URL || 'http://localhost:4001/fallback',
  GRAPHQL_ENDPOINT: process.env?.REACT_APP_API_BASE_URL ? process.env?.REACT_APP_API_BASE_URL + '/graphql' : '/graphql/fallback',
  APP_ENV: process.env?.REACT_APP_APP_ENV || 'unknown',
  COMMIT_SHA: process.env?.REACT_APP_VERCEL_GIT_COMMIT_SHA || 'unknown',
}

// Warn if any runtime configuration values are missing or if fallback values are being used.
if (process.env?.API_BASE_URL === undefined || config.API_BASE_URL.includes('/fallback')) {
  console.warn('[CONFIG_WARNING] API_BASE_URL may not be properly set.')
}
if (process.env?.GRAPHQL_ENDPOINT === undefined || config.GRAPHQL_ENDPOINT.includes('/fallback')) {
  console.warn('[CONFIG_WARNING] GRAPHQL_ENDPOINT may not be properly set.')
}
if (process.env?.APP_ENV === undefined || config.APP_ENV === 'unknown') {
  console.warn('[CONFIG_WARNING] APP_ENV may not be properly set.')
}
if (process.env?.COMMIT_SHA === undefined || config.COMMIT_SHA === 'unknown') {
  console.warn('[CONFIG_WARNING] COMMIT_SHA may not be properly set.')
}

export default config
